var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "previewBox"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.previewUrl,
      "allowfullscreen": ""
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };